'use client';

import { redirect } from 'next/navigation';

export default function HomeRedirect() {
  // Get user's language from localStorage (default to 'en')
  const language = localStorage.getItem('i18nextLng') || 'en';

  // Redirect / → language-specific home page
  redirect(`/${language}`);
}
